let restUrl = process.env.API_ROOT;
export {restUrl}




//////////////////
// WEBPACK FOOTER
// ./url.js
// module id = null
// module chunks = 